function isBase64(str) {
    if (str === '' || str.trim() === '') { return false; }
    try {
        return btoa(atob(str)) == str;
    } catch (err) {
        return false;
    }
}

function decodeBase64(str) {
    if (isBase64(str)) {
        //decode this shit.
        return atob(str);
    }
}

function encodeBase64(str) {
    return btoa(str);
}

export {
    isBase64,
    encodeBase64,
    decodeBase64
}